









import Vue, { PropOptions } from 'vue';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import deepClone from '../../utils/deepClone';

export interface DatePickerConfig {
  inline?: boolean;
  mode?: 'range';
  showMonths?: number;
  altInput?: boolean;
  altFormat?: string;
  dateFormat?: string;
  // eslint-disable-next-line camelcase
  time_24hr?: boolean;
  onClose?: () => {};
  defaultDate?: string;
  enableTime?: boolean;
  minDate?: string;
  maxDate?: string;
}

/**
  A basic date picker, not in a text input or dropdown.
  You might be looking for SInputDate
 */
export default Vue.extend({
  props: {
    value: {
      type: [String, Array],
      required: false,
    },
    config: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    } as PropOptions<DatePickerConfig>,
    container: {
      // type: Object,
      required: false,
      validator(value) {
        // Prevent warning about HTMLInputElement not being an object even though it is
        return typeof value === 'object';
      },
    } as PropOptions<HTMLInputElement>,
    // Pick UTC dates rather than dates in local time. Picking dates in localtime can cause
    // issues later on converting between formats or rendering to ISOStrings
    utcMode: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data(): any {
    const self: any = this;
    return {
      previousConfig: {} as DatePickerConfig,
      selectedDate: self.value,
    };
  },
  watch: {
    config() {
      const clone = deepClone(this.config) as DatePickerConfig;

      // Datepicker doesn't like showMonths being changed
      if (this.previousConfig.showMonths !== this.config.showMonths) {
        this.destroyDatepicker();
        this.initDatepicker();
        this.previousConfig = clone;
        return;
      }

      this.previousConfig = clone;

      Object.keys(this.config).forEach((key) => {
        if (key === 'showMonths') {
          return;
        }
        const value = this.config[key];
        this.datePicker.set(key, value);
      });
    },
    value(newValue) {
      this.datePicker.setDate(newValue);
    },
    selectedDate(newValue) {
      this.datePicker.setDate(newValue);
    },
  },
  mounted() {
    this.previousConfig = deepClone(this.config);
    this.initDatepicker();
  },
  beforeDestroy() {
    // This stops the modal window shrinking when its closing
    const { width } = this.$refs['container-parent'].getBoundingClientRect();
    this.$refs['container-parent'].style.width = `${width}px`;

    this.destroyDatepicker();
  },
  methods: {
    dateChange(selectedDates) {
      const { enableTime } = this.config;
      this.selectedDate = selectedDates;
      let dates = selectedDates;

      if (this.utcMode) {
        dates = selectedDates
          .map((date: Date): Date => {
            const UTCDate = new Date(
              Date.UTC(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                enableTime ? date.getHours() : 0,
                enableTime ? date.getMinutes() : 0,
              ),
            );
            return UTCDate;
          });
      }
      this.$emit('input', dates);
    },
    destroyDatepicker() {
      this.datePicker.destroy();
    },
    initDatepicker() {
      const container = (this.container || this.$refs.container) as HTMLElement;

      this.datePicker = flatpickr(container, {
        ...this.config,
        onChange: this.dateChange,
        defaultDate: this.value,
      });
    },
  },
});
